import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { o as oneIsDefined } from '../prop-types/oneIsDefined-YS0WmAda.js';
import { R as RadioGroupProvider } from './RadioGroupContext-DsoCoIZR.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { R as RadioButtonGroup } from './RadioButtonGroup/RadioButtonGroup-CXcabDAC.js';

// extends Record<string, unknown>

const RadioGroupComponent = ({
  children,
  disabled,
  hideLabel,
  inlineLabel,
  inline,
  name,
  label,
  onChange,
  // removing this, it's handled by bubbled children events
  selectedValue,
  ...rest
}) => {
  const handleRadioChange = (event, value) => {
    if (onChange && value !== selectedValue) {
      onChange(value, event);
    }
  };
  return /*#__PURE__*/React__default.createElement(RadioGroupProvider, {
    handleRadioChange: handleRadioChange,
    isGroupInline: inline,
    isGroupDisabled: disabled,
    name: name,
    selectedValue: selectedValue
  }, /*#__PURE__*/React__default.createElement(RadioButtonGroup, _extends({}, rest, {
    inline: inline,
    inlineLabel: inlineLabel,
    label: label,
    disabled: disabled,
    hideLabel: hideLabel
  }), children));
};
RadioGroupComponent.defaultProps = {
  hideLabel: false,
  inlineLabel: false,
  onChange: undefined,
  selectedValue: undefined,
  label: undefined,
  'aria-labelledby': undefined,
  inline: false,
  disabled: false
};
const RadioGroup = /*#__PURE__*/styled(RadioGroupComponent).withConfig({
  componentId: "sc-storm-ui-30060407__sc-1j8zlw1-0"
})([""]);
RadioGroup.displayName = 'RadioGroup';
RadioGroup.propTypes = {
  /**
   * The <RadioButton> components to be rendered by the <RadioGroup>.
   */
  children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]).isRequired,
  ...oneIsDefined({
    /**
     * Label for the RadioGroup
     */
    label: PT.node,
    /**
     * The string id of a external label element
     */
    'aria-labelledby': PT.string
  }),
  /**
   * This MUST be unique, and it allows the group to manage all children properly.
   */
  name: PT.string.isRequired,
  /**
   * Labels are required for screen reader accessibility, but can be hidden visually.
   */
  hideLabel: PT.bool,
  /**
   * Positions the legend for the <RadioGroup> inline with the <RadioButton> controls.
   */
  inlineLabel: PT.bool,
  /**
   * Callback that is called when the user chooses a different <RadioButton> option.
   */
  onChange: PT.func,
  /**
   * Signifies the selected option in the <RadioGroup>
   */
  selectedValue: PT.string,
  /**
   * Positions the <RadioButton> components inline instead of stacked.
   */
  inline: PT.bool
};
RadioGroup.defaultProps = {
  hideLabel: false,
  inlineLabel: false,
  selectedValue: '',
  inline: false,
  onChange: noop
};

export { RadioGroup as R };
//# sourceMappingURL=RadioGroup-DN31vZZo.js.map
